/**
 * Created by Daniela on 23/01/2017.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";

import { FrotasService } from "../shared/frota.service";
import { FrotaNavigationService } from "../shared/frota-navigation.service";
import { FrotaApiService } from "../shared/frota-api.service";
import {
    aeronavesRoute, embarcacoesRoute, equipamentosRoute, maquinarioRoute,
    outrosRoute, veiculosRoute
} from "../shared/data.service";

@Component({
    template: require('./frota-detail.component.html'),
    styles: [require('./frota-detail.component.css')]
})
export class FrotaDetailComponent implements OnInit {
    frotasModule: any = {};
    thisRoute:string = '';
    detail: any = {};
    loading: boolean = true;

    aeronavesRoute: string = aeronavesRoute;
    embarcacoesRoute: string = embarcacoesRoute;
    equipamentosRoute: string = equipamentosRoute;
    maquinarioRoute: string = maquinarioRoute;
    outrosRoute: string = outrosRoute;
    veiculosRoute: string = veiculosRoute;

    private moduleId: number;

    constructor(
        private _frotaService: FrotasService,
        private _frotaNavigationService: FrotaNavigationService,
        private _frotaApiService: FrotaApiService,
        private _route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.frotasModule = this._frotaService.getModuleName();
        this.thisRoute = this._frotaService.getRouteName();
        this.moduleId = this._frotaService.getModuleId();

        let id = +this._route.snapshot.params['id'];
        this.getObject(id);
    }

    clickGoToList() {
        this._frotaNavigationService.goToList(this.thisRoute);
    }

    clickGoToForm() {
        this._frotaService.setBackStorage(this.detail);
        this._frotaNavigationService.goToEdit(this.detail.id, this.thisRoute);
    }

    clickGoToAbastecimentos() {
        this._frotaService.setBackStorage(this.detail);
        this._frotaNavigationService.goToFrotaAbastecimento(this.thisRoute);
    }

    clickGoToDeslocamentos() {
        this._frotaService.setBackStorage(this.detail);
        this._frotaNavigationService.goToFrotaDeslocamento(this.thisRoute);
    }

    clickGoToManutencao() {
        this._frotaService.setBackStorage(this.detail);
        this._frotaNavigationService.goToFrotaManutencao(this.thisRoute);
    }

    clickGoToPlanoManutencao() {
        this._frotaService.setBackStorage(this.detail);
        this._frotaNavigationService.goToFrotaPlanoManutencao(this.thisRoute);
    }

    clickGoToPhotos() {
        this._frotaService.setBackStorage(this.detail);
        this._frotaNavigationService.goToFrotaImagem(this.detail.id, this.thisRoute);
    }

    clickGoToOdometroHorimetro() {
        this._frotaService.setBackStorage(this.detail);
        this._frotaNavigationService.goToFrotaOdometroHorimetro(this.detail.id, this.thisRoute);
    }

    private getObject(id: number) {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                const storage = this._frotaService.getSessionStorage();
                if (storage) {
                    Response.Combustiveis = storage.Combustiveis;
                }
                this.detail = Response;
                this.loading = false;
            } else {
                this._utilService.swalMessageWarningCustom('Nenhum ' + this.frotasModule.single + ' encontrado com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._frotaApiService.onGetById(id, onDone);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/frotas/frota-detail/frota-detail.component.ts
 **/